// extracted by mini-css-extract-plugin
export default {"field":"Field_field__YgGxp","lead":"Field_lead__OIEMs","rotate":"Field_rotate__Uco4l"};